import { IconDefinition } from '@ant-design/icons-angular';
import {
  PlusOutline,
  QuestionCircleFill,
  SearchOutline,
  CloseOutline,
  TwitterOutline,
  EditOutline,
  FileExcelTwoTone,
  QuestionCircleOutline,
  FieldTimeOutline,
  PrinterOutline,
  SaveOutline,
  ExportOutline,
  ImportOutline,
  FileSearchOutline,
  ArrowDownOutline,
  ArrowUpOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  CaretLeftOutline,
  CaretRightOutline,
  TeamOutline,
  PicRightOutline,
  DeleteOutline,
  SettingOutline,
  SwapOutline,
  UserOutline,
  MailFill,
  MailOutline,
  BellFill,
  BellOutline,
  MessageFill,
  MessageOutline,
  ClusterOutline,
  ClearOutline,
  KeyOutline,
  LogoutOutline,
  DashOutline,
  DashboardOutline,
  ControlOutline,
  HomeOutline,
  UserAddOutline,
  RedoOutline,
  DeploymentUnitOutline,
  SolutionOutline,
  WalletOutline,
  HeartOutline,
  BookOutline,
  SecurityScanOutline,
  CodeOutline,
  MedicineBoxOutline,
  ProfileOutline,
  MoneyCollectOutline,
  AuditOutline,
  ShoppingOutline,
  TagOutline,
  LikeOutline,
  LikeTwoTone,
  DislikeOutline,
  DislikeTwoTone,
  StarOutline,
  SendOutline,
  FilterOutline,
  PlusCircleFill,
  InfoCircleFill,
  FolderOpenFill,
  FolderFill,
  GroupOutline,
  UngroupOutline,
  UnlockOutline,
  UsergroupAddOutline,
  ContactsOutline,
  DeliveredProcedureOutline,
  PlusSquareOutline,
  TagsOutline,
  MinusSquareOutline,
  RadiusUpleftOutline,
  ForwardOutline,
  DoubleRightOutline,
  DownloadOutline,
  CloseSquareOutline,
  CaretDownFill,
  ArrowsAltOutline,
  ShrinkOutline,
  ReloadOutline,
  FileExcelOutline,
  CheckOutline,
  LineOutline
} from '@ant-design/icons-angular/icons';

export const NZ_NDHUY_ICONS: IconDefinition[] = [
  DownloadOutline,
  CheckOutline,
  DoubleRightOutline,
  ForwardOutline,
  ContactsOutline,
  FolderFill,
  QuestionCircleFill,
  PlusOutline,
  SearchOutline,
  CloseOutline,
  TwitterOutline,
  EditOutline,
  FileExcelTwoTone,
  FileExcelOutline,
  QuestionCircleOutline,
  FieldTimeOutline,
  PrinterOutline,
  SaveOutline,
  ExportOutline,
  ImportOutline,
  FileSearchOutline,
  ArrowDownOutline,
  ArrowUpOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  CaretLeftOutline,
  CaretRightOutline,
  TeamOutline,
  PicRightOutline,
  DeleteOutline,
  SettingOutline,
  SwapOutline,
  UserOutline,
  MailFill,
  MailOutline,
  BellFill,
  BellOutline,
  MessageFill,
  MessageOutline,
  ClusterOutline,
  ClearOutline,
  KeyOutline,
  LogoutOutline,
  DashOutline,
  DashboardOutline,
  ControlOutline,
  HomeOutline,
  UserAddOutline,
  RedoOutline,
  SolutionOutline,
  WalletOutline,
  HeartOutline,
  BookOutline,
  SecurityScanOutline,
  CodeOutline,
  MedicineBoxOutline,
  ProfileOutline,
  MoneyCollectOutline,
  AuditOutline,
  ShoppingOutline,
  TagOutline,
  LikeOutline,
  LikeTwoTone,
  DislikeOutline,
  DislikeTwoTone,
  DeploymentUnitOutline,
  StarOutline,
  SendOutline,
  FilterOutline,
  PlusCircleFill,
  InfoCircleFill,
  FolderOpenFill,
  GroupOutline,
  UngroupOutline,
  UnlockOutline,
  UsergroupAddOutline,
  DeliveredProcedureOutline,
  PlusSquareOutline,
  TagsOutline,
  MinusSquareOutline,
  RadiusUpleftOutline,
  CloseSquareOutline,
  CaretDownFill,
  ArrowsAltOutline,
  ShrinkOutline,
  ReloadOutline,
  LineOutline
];
